import AwaitingImplementation from '@views/error-pages/AwaitingImplementation'

export default function Matching() {
	return <AwaitingImplementation />
}
